import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useEffect, useState } from 'react';
import config from '../../config';
import axios from 'axios';
import RegistrationDateSelector from '../molecules/RegistrationDateSelector';
import { Paper } from '@mui/material';

const RegistrationChildSacraments = ({
  childObject,
  updateChild,
  clearDateTrigger,
  validation,
}) => {
  const [churchList, setChurchList] = useState([]);
  const [baptismDate, setBaptismDate] = useState('');
  const [reconDate, setReconDate] = useState('');
  const [holyCommDate, setHolyComm] = useState('');
  const [localClearTrigger, setLocalClearTrigger] = useState(0);

  const isBaptised = childObject['baptised'] === 'yes';

  const SACRAMENT_TEXT_FIELDS = [
    'baptism_church',
    'baptism_church_ovr',
    'first_recon_church',
    'first_recon_church_ovr',
    'holy_comm_church',
    'holy_comm_church_ovr',
  ];

  const handleBaptisedChange = e => {
    updateChild(e.target);
    if (e.target.value === 'no') {
      setBaptismDate('');
      setReconDate('');
      setHolyComm('');
      setLocalClearTrigger(prev => prev + 1);
      SACRAMENT_TEXT_FIELDS.forEach(name => updateChild({ name, value: '' }));
    }
  };

  useEffect(() => {
    const sacramentDates = [
      {
        name: 'baptism_date',
        value: baptismDate,
      },
      {
        name: 'first_recon_date',
        value: reconDate,
      },
      {
        name: 'holy_comm_date',
        value: holyCommDate,
      },
    ];

    sacramentDates.forEach(sacramentDate => {
      updateChild(sacramentDate);
    });
  }, [baptismDate, reconDate, holyCommDate]);

  const handleFormChange = e => {
    updateChild(e.target);
  };

  useEffect(() => {
    // get list of churches to populate select box
    axios
      .get(config.CHURCH_API)
      .then(output => {
        setChurchList(output.data.response);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  return (
    <div>
      <Paper elevation={5} sx={{ padding: '20px' }}>
        <TextField
          fullWidth
          select
          margin='dense'
          name='baptised'
          label='My child has been baptized'
          id='student_baptised'
          value={childObject['baptised'] ?? 'no'}
          onChange={handleBaptisedChange}
          inputProps={{ 'data-cy': 'child-baptised' }}
        >
          <MenuItem value='no'>No</MenuItem>
          <MenuItem value='yes'>Yes</MenuItem>
        </TextField>

        <div className='spacer'></div>

        <div className='pHeader'>Baptism</div>
        <RegistrationDateSelector
          dateObjSetter={setBaptismDate}
          clearDateTrigger={clearDateTrigger + localClearTrigger}
          required={isBaptised}
          validationState={validation.baptism_date}
          testid='baptism'
          disabled={!isBaptised}
        />

        <TextField
          fullWidth
          select
          disabled={!isBaptised}
          name='baptism_church'
          label='Baptism Church (Singapore)'
          margin='dense'
          value={childObject['baptism_church'] ?? ''}
          onChange={handleFormChange}
          inputProps={{ 'data-cy': 'child-baptism-church' }}
          id='child-baptism-church'
        >
          {churchList?.map(church => (
            <MenuItem
              key={church.church_id}
              value={church.church_id.toString()}
            >
              {church.church_name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          fullWidth
          multiline
          disabled={!isBaptised}
          label="IF Baptised Overseas, please provide the church's name and address:"
          rows='3'
          value={childObject['baptism_church_ovr']}
          margin='dense'
          name='baptism_church_ovr'
          onChange={handleFormChange}
          inputProps={{ 'data-cy': 'child-baptism-church-overseas' }}
        ></TextField>

        <div className='spacer'></div>

        <div className='pHeader'>First Reconciliation</div>
        <RegistrationDateSelector
          dateObjSetter={setReconDate}
          clearDateTrigger={clearDateTrigger + localClearTrigger}
          testid='recon'
          disabled={!isBaptised}
        />
        <TextField
          fullWidth
          select
          disabled={!isBaptised}
          value={childObject['first_recon_church'] ?? ''}
          name='first_recon_church'
          label='Church where First Reconciliation was received (Singapore)'
          margin='dense'
          onChange={handleFormChange}
          id='child-recon-church'
        >
          {churchList?.map(church => (
            <MenuItem
              key={church.church_id}
              value={church.church_id.toString()}
            >
              {church.church_name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          fullWidth
          disabled={!isBaptised}
          label={
            "IF Sacrament of Reconciliation conferred Overseas, please provide the church's name and address:"
          }
          multiline
          rows='3'
          value={childObject['first_recon_church_ovr']}
          margin='dense'
          name='first_recon_church_ovr'
          onChange={handleFormChange}
          inputProps={{ 'data-cy': 'child-recon-church-overseas' }}
        ></TextField>

        <div className='spacer'></div>

        <div className='pHeader'>First Holy Communion</div>
        <RegistrationDateSelector
          dateObjSetter={setHolyComm}
          clearDateTrigger={clearDateTrigger + localClearTrigger}
          testid='comm'
          disabled={!isBaptised}
        />
        <TextField
          fullWidth
          required
          select
          disabled={!isBaptised}
          value={childObject['holy_comm_church'] ?? ''}
          name='holy_comm_church'
          label='Church where First Holy Communion was received (Singapore)'
          margin='dense'
          onChange={handleFormChange}
          id='child-holy-comm-church'
        >
          {churchList?.map(church => (
            <MenuItem
              key={church.church_id}
              value={church.church_id.toString()}
            >
              {church.church_name}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          fullWidth
          multiline
          disabled={!isBaptised}
          label="IF Sacrament of First Holy Communion conferred Overseas, please provide the church's name and address:"
          rows='3'
          margin='dense'
          value={childObject['holy_comm_church_ovr']}
          name='holy_comm_church_ovr'
          onChange={handleFormChange}
          inputProps={{ 'data-cy': 'child-holy-comm-church-overseas' }}
        ></TextField>
      </Paper>
    </div>
  );
};

export default RegistrationChildSacraments;
